import { IReportSettings } from 'partner360/models/report/generalReports/IReportSettings'

export const getRoots = (reports: IReportSettings[]) => {
  const uniqueParents = new Map<string, { id: string; desc: string; name: string }>()

  reports.forEach(({ ParentId, ParentDescription, ParentName }) => {
    if (ParentId && !uniqueParents.has(ParentId)) {
      uniqueParents.set(ParentId, {
        id: ParentId,
        desc: ParentDescription || '',
        name: ParentName || '',
      })
    }
  })

  return Array.from(uniqueParents.values())
}
